import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IListLayout } from 'src/app/models/interfaces/list-layout.interface';

export class ListLayoutWorkflowsDetailContext extends DefaultDetailContext<IListLayout, number> {}
